
/* eslint-disable import/prefer-default-export */
/* eslint-disable no-undef */

import { KEY_DATA_GRID_STATE_IN_LS } from '../transcript-viewer/transcripts-table/constants'

export function clearDataGridState() {
  const dataGridState = JSON.parse(window.localStorage.getItem(KEY_DATA_GRID_STATE_IN_LS))
  dataGridState.columns.forEach((column, ii) => {
    if (column.groupIndex !== undefined) {
      delete dataGridState.columns[ii].groupIndex
    }
    if (column.filterValue !== undefined) {
      delete dataGridState.columns[ii].filterValue
    }
    if (column.filterValues !== undefined) {
      delete dataGridState.columns[ii].filterValues
    }
  })
  window.localStorage.setItem(KEY_DATA_GRID_STATE_IN_LS, JSON.stringify(dataGridState))
}
